import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./info.svg?react";

export const InfoIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
